<template></template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import ActivityHiddenContainerComponent from './ActivityHiddenContainerComponent.vue';

@Component
export default class ActivityHiddenVideoWithLabel extends ActivityHiddenContainerComponent {}
</script>
